import PageLayout from "@/components/layout/PageLayout";
import PageBreadcrumb from "@/components/layout/PageBreadcrumb";
import { FileCheck2, ClipboardCheck, MessageCircle, CheckCircle2 } from "lucide-react";
import Cities from "@/components/sections/Cities";

const ClaimsProcessPage = () => {
  return (
    <PageLayout>
      <PageBreadcrumb currentPage="Claims Process" />
      <section className="py-6 sm:py-8 px-4 bg-gradient-to-b from-white to-purple-50">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white rounded-lg shadow-sm p-8 animate-fade-up">
            <h1 className="text-3xl sm:text-4xl font-bold text-primary-dark mb-6 text-center">
              Insurance Claims Process
            </h1>
            <p className="text-neutral text-lg mb-12 text-center">
              We strive to make your claims process as smooth and efficient as possible. Follow these steps to file your claim.
            </p>

            <div className="space-y-8">
              {/* Step 1 */}
              <div className="flex flex-col md:flex-row gap-6 items-start p-6 rounded-lg hover:bg-purple-50 transition-colors">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
                  <FileCheck2 className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-primary-dark mb-2">1. Report Your Claim</h3>
                  <p className="text-neutral mb-4">
                    Contact our claims department immediately after the incident. You can report your claim:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-neutral">
                    <li>Call our 24/7 claims hotline: (217) 909-9777</li>
                    <li>Submit online through your customer portal</li>
                    <li>Contact your local KoverKing agent</li>
                  </ul>
                </div>
              </div>

              {/* Step 2 */}
              <div className="flex flex-col md:flex-row gap-6 items-start p-6 rounded-lg hover:bg-purple-50 transition-colors">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
                  <ClipboardCheck className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-primary-dark mb-2">2. Documentation</h3>
                  <p className="text-neutral mb-4">
                    Gather and submit all relevant documentation to support your claim:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-neutral">
                    <li>Photos of damage or incident</li>
                    <li>Police reports (if applicable)</li>
                    <li>Medical records (for injury claims)</li>
                    <li>Receipts and estimates</li>
                  </ul>
                </div>
              </div>

              {/* Step 3 */}
              <div className="flex flex-col md:flex-row gap-6 items-start p-6 rounded-lg hover:bg-purple-50 transition-colors">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
                  <MessageCircle className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-primary-dark mb-2">3. Claims Assessment</h3>
                  <p className="text-neutral mb-4">
                    A dedicated claims adjuster will be assigned to your case and will:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-neutral">
                    <li>Review your policy coverage</li>
                    <li>Evaluate the submitted documentation</li>
                    <li>Schedule necessary inspections</li>
                    <li>Keep you informed throughout the process</li>
                  </ul>
                </div>
              </div>

              {/* Step 4 */}
              <div className="flex flex-col md:flex-row gap-6 items-start p-6 rounded-lg hover:bg-purple-50 transition-colors">
                <div className="flex items-center justify-center w-12 h-12 bg-primary/10 rounded-full shrink-0">
                  <CheckCircle2 className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-primary-dark mb-2">4. Resolution</h3>
                  <p className="text-neutral mb-4">
                    Once your claim is approved:
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-neutral">
                    <li>Receive detailed explanation of settlement</li>
                    <li>Choose your preferred payment method</li>
                    <li>Get guidance on repair or replacement process</li>
                    <li>Access to post-claim support if needed</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="mt-12 p-6 bg-primary/5 rounded-lg">
              <h4 className="text-xl font-semibold text-primary-dark mb-4">Need Assistance?</h4>
              <p className="text-neutral mb-4">
                Our claims support team is available 24/7 to help you through every step of the process.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <a 
                  href="tel:217-909-9777"
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
                >
                  Call Claims Support
                </a>
                <button 
                  className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-primary text-primary rounded-lg hover:bg-primary/10 transition-colors"
                >
                  Chat with an Agent
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Cities />
    </PageLayout>
  );
};

export default ClaimsProcessPage;